/**
 * Compass Rose
 *
 * Home page background element: slowly rotating compass rings with
 * cardinal/intercardinal direction lines, N/S/E/W arrowheads, and
 * a pulsing diamond center. Evokes authority and strategic command.
 */

import React from 'react';

export const CompassRose: React.FC = () => {
  return (
    <div className="compass-layer">
      {/* Outer ring — rotates CW */}
      <div className="compass-ring" />

      {/* Inner ring — rotates CCW */}
      <div className="compass-ring-inner" />

      {/* Cardinal + intercardinal lines — rotate with outer ring */}
      <div className="compass-cardinals">
        <div className="compass-cardinal" />
        <div className="compass-cardinal" />
        <div className="compass-cardinal" />
        <div className="compass-cardinal" />
        <div className="compass-intercardinal" />
        <div className="compass-intercardinal" />
        <div className="compass-intercardinal" />
        <div className="compass-intercardinal" />
      </div>

      {/* N/S/E/W arrowheads */}
      <div className="compass-arrow compass-arrow-n" />
      <div className="compass-arrow compass-arrow-s" />
      <div className="compass-arrow compass-arrow-e" />
      <div className="compass-arrow compass-arrow-w" />

      {/* Center diamond with inner diamond + dot */}
      <div className="compass-rose-center" />
    </div>
  );
};
